module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: _vm.box_cls
  }, [(_vm.label) ? _c('div', {
    staticClass: "header",
    class: {
      'togglable': (_vm.headerToggle != undefined)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.headerToggleOpen()
      }
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.label) + "\n      "), (_vm.is_open == true || _vm.is_open == false) ? _c('div', {
    staticClass: "toggler",
    class: {
      open: (_vm.is_open === true)
    },
    on: {
      "click": function($event) {
        return _vm.togglerToggleOpen()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-right"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$slots['meta-r']) ? _c('div', {
    staticClass: "meta-r"
  }, [_vm._t("meta-r")], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.is_open === undefined || _vm.is_open === true) ? _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eb89163","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Box.vue
// module id = 592
// module chunks = 1